import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
// material ui
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
// components
import Contact from './widgets/Contact.js';
import Custom from './widgets/Custom.js';
import EventResults from './widgets/EventResults.js';
import Header from './sub/Header.js';
import Leaderboard from './widgets/Leaderboard.js';
import Message from './widgets/Message.js';
import Photo from './widgets/Photo.js';
import TipJar from './widgets/TipJar.js';
import Theme from '../Theme.js';
// helpers
import { buildColumns, handleScroll, initFacebookShare, layoutVariables } from './helpers.js'

const useStyles = makeStyles({
  body: {
    backgroundColor: Theme.bgColorMd,
    overflow: 'hidden',
  },
  content: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    alignSelf: 'center',
    width: '100%',
    maxWidth: layoutVariables.totalContentWidth + 'px',
    marginTop: props => props.mode == "live" ? layoutVariables.contentMarginTop + 'px' : '0px',
    paddingTop: layoutVariables.contentPaddingTop + 'px',
    paddingBottom: layoutVariables.contentPaddingBottom + 'px',
    '&.onlyLeft': {
      justifyContent: 'center',
    },
    '&.onlyRight': {
      justifyContent: 'center',
      '& #contentLeft': {
        width: '0',
      },
      '& #contentRight': {
        position: 'static',
      },
    },
  },
  contentMobile: {
    backgroundColor: Theme.bgColorDark,
    display: 'block',
    margin: '0 auto',
    maxWidth: '400px',
    paddingTop: (layoutVariables.mobileHeaderHeight + 10) + 'px',
    width: '100%',
    "& > .cardMobile": {
      backgroundColor: '#ffffff',
      borderRadius: '0px',
      boxShadow: 'none',
      marginBottom: '10px',
    },
  },
  contentLeft: {
    display: 'block',
    float: 'left',
    width: (layoutVariables.leftColWidth/layoutVariables.totalContentWidth*100) + '%',
  },
  contentRight: {
    display: 'block',
    position: 'absolute',
    right: 0,
    width: (layoutVariables.rightColWidth/layoutVariables.totalContentWidth*100) + '%',
  },
  pageLoaded: {
    opacity: '0 !important',
  },
});

export default function Debrief(props) {
  const { view, widgets } = props;
  const mode = window.mode;
  const [isMobile, setIsMobile] = useState(true);
  const classes = useStyles({ mode });
  if (mode == 'live') document.body.classList.add(classes.body);

  const components = {
    contact_post: Contact,
    Custom: Custom,
    event_results: EventResults,
    leaderboard: Leaderboard,
    message_post: Message,
    photo_post: Photo,
    tipjar_post: TipJar,
  }

  // exclude keys in widgets from widget list
  const excludedKeys = ['custom_css']
  const widgetList = Object.entries(widgets).filter(([key, _]) => !excludedKeys.includes(key));
  if (isMobile) {
    var mobile1 = buildColumns(widgetList, "mobile", 1);
  } else {
    var desktop1 = buildColumns(widgetList, "desktop", 1);
    var desktop2 = buildColumns(widgetList, "desktop", 2);
    var onlyLeft = false;
    var onlyRight = false;
    if (desktop1.length > 0 && desktop2.length == 0) {
      onlyLeft = true;
    }
    if (desktop2.length > 0 && desktop1.length == 0) {
      onlyRight = true;
    }
  }

  const desktopContent = clsx({
    [classes.content]: true,
    'onlyLeft': onlyLeft ? true : false,
    'onlyRight': onlyRight ? true : false,
  })

  useEffect(() => {
    if (mode == 'live') {
      initFacebookShare(window.fbAppId);
      var windowWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
      if (windowWidth > layoutVariables.maxMobileWidth) {
        setIsMobile(false);
        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleScroll);
      }
      setTimeout( function() {
        document.getElementById('loading-page').style.opacity = 0;
        setTimeout( function() {
          document.getElementById('loading-page').style.zIndex = 0;
          document.body.style.overflow = 'auto';
        }, 600);
      }, 2500);
    } else {
      (view == 'desktop') ? setIsMobile(false) : setIsMobile(true);
    }
  }, [view]);

  useEffect(() => {
    let customCssStyleTag = document.getElementById('custom-css')
    if (!customCssStyleTag) {
      const head = document.head || document.getElementsByTagName('head')[0]
      customCssStyleTag = document.createElement('style')
      customCssStyleTag.type = 'text/css'
      customCssStyleTag.id = 'custom-css'
      head.appendChild(customCssStyleTag)
    }
    if (widgets?.custom_css) {
      customCssStyleTag.innerText = widgets.custom_css
    }
  }, [widgets.custom_css])

  return (
    <>
    {isMobile ? (
      <>
      <Header device="mobile" />
      <Box className={classes.contentMobile + ` mobile content ${mode}`} >
        {mobile1.map((widget, index) => {
          if (widget[1]['component'] === 'message_post') {
            if (!(window.hideReviewWidget === 'True' && window.mode === 'live')) {
              let Component = components[widget[1]['component']];
              return <Component key={index} context={widget[1]} screen="mobile" />;
            }
          } else {
            let Component = components[widget[1]['component']];
            return <Component key={index} context={widget[1]} screen="mobile" />;
          }
        })}
      </Box>
      </>
    ) : (
      <>
      <Header device="desktop" />
      <Box className={desktopContent + ` desktop content ${mode}`} >
        <Box id="contentLeft" className={classes.contentLeft} >
          {desktop1.map((widget, index) => {
            if (widget[1]['component'] === 'message_post') {
              if (!(window.hideReviewWidget === 'True' && window.mode === 'live')) {
                let Component = components[widget[1]['component']];
                return <Component key={index} context={widget[1]} screen="desktop" />;
              }
            } else {
              let Component = components[widget[1]['component']];
              return <Component key={index} context={widget[1]} screen="desktop" />;
            }
          })}
        </Box>
        <Box id="contentRight" className={classes.contentRight} >
          {desktop2.map((widget, index) => {
            if (widget[1]['component'] === 'message_post') {
              if (!(window.hideReviewWidget === 'True' && window.mode === 'live')) {
                let Component = components[widget[1]['component']];
                return <Component key={index} context={widget[1]} screen="desktop" />;
              }
            } else {
              let Component = components[widget[1]['component']];
              return <Component key={index} context={widget[1]} screen="desktop" />;
            }
          })}
        </Box>
      </Box>
      </>
    )}
    </>
  );
}

